<template>
    <div class="current-floor">
        <div class="floor-content" v-loading="loading"
        element-loading-background="rgba(0, 0, 0, 0.2)">
            <div class="floor-header">
                <img class="back" src="@/assets/images/back.png" alt="返回" @touchstart="back" @click="back">

                <div class="title-wrapper">
                    <div class="title-line"></div>
                    <div class="title">{{ data.name }}</div>
                    <div class="title-line"></div>
                </div>

            </div>
            <div class="floor-body">
                <div v-if="graphJson" class="graph-container" id="containerChart"></div>
                <!--          <div v-if="graphJson" style="position: absolute;right: 0;bottom: 10%" id="minimapContainer"></div>-->
                <noData v-else
                    style="height: 50%;display: flex;align-items: center;justify-content: center;flex-direction: column">
                </noData>
            </div>
        </div>
    </div>
</template>

<script>
import '@antv/x6-vue-shape'
import { Graph, Shape } from '@antv/x6';
import noData from "@/components/NoData"
import insertCss from 'insert-css';
import { getSpaceTreeData } from '@/network/space-info';
import { getTopologyBySpaceName } from "@/network/device-topology"

export default {
    name: 'CurrentFloor',
    ccomponents: {
        noData
    },
    data() {
        return {
            loading: false,
            edgeObject: {
                attrs: {
                    line: {
                        stroke: '#CCCCCC',
                        strokeWidth: 4,
                        targetMarker: {
                            name: 'classic',
                            size: 8
                        },
                        strokeDasharray: 0, //虚线
                        style: {
                            animation: 'ant-line 30s infinite linear',
                        },
                    },
                },
                // 连接方式（默认单向箭头）
                connector: 'normal',
                router: {
                    name: ''
                },
                label: {
                    text: ''
                },
                zIndex: 2
            },
            grid: { // 网格设置
                size: 20,      // 网格大小 10
                visible: true, // 渲染网格背景
                type: 'mesh',
                args: {
                    color: '#0E2E48',
                    thickness: 1,     // 网格线宽度/网格点大小
                    factor: 10,
                }
            },
            graphJson: {},
            spaceTree: [],
            data: {
                name: '',
                dataJson: ''
            }
        }
    },
    created() {
        const spaceName = this.$route.query.spaceName;
        if (spaceName) {
            this.loading = true;
            getTopologyBySpaceName(spaceName).then(res => {
                console.log(res, 'res');
                this.loading = false;
                this.data.dataJson = res.data.dataJson;
                this.data.name = res.data.name;
                this.initX6()
                this.queryTopology()
            });
        }

    },
    mounted() {
        this.getSpaceTreeData();
    },
    destroyed() {
        this.graph.dispose()
    },
    methods: {
        back() {
            this.$router.go(-1);
        },
        // 根据空间id获取空间名称
        getSpaceName(spaceId) {
            // 递归查找空间名称
            const findSpaceName = (tree, id) => {
                for (let node of tree) {
                    // 如果找到匹配的ID，返回该节点的标题
                    if (node.id === id) {
                        return node.title;
                    }
                    // 如果有子节点，递归查找
                    if (node.children && node.children.length) {
                        const found = findSpaceName(node.children, id);
                        if (found) return found;
                    }
                }
                return null;
            };

            return findSpaceName(this.spaceTree, spaceId) || '未知空间';
        },
        getSpaceTreeData() {
            getSpaceTreeData().then(res => {
                if (res.code === 0) {
                    // 将树转换成需要的格式
                    this.spaceTree = res.data;
                }
            });
        },
        queryTopology() {
            this.graphJson = JSON.parse(this.data.dataJson)
            this.graph.on('node:click', (e, node) => {
            console.log(node);
            if (e.cell.data && e.cell.data.spaceId) {
                const length = e.cell.data.spaceId.length;
                const spaceId = e.cell.data.spaceId[length - 1];
                const spaceName = this.getSpaceName(spaceId);
                console.log('空间名称:', spaceName);

                this.$router.push({
                    name: '综合态势',
                    query: {
                        spaceId: spaceId,
                        spaceName: spaceName
                    }
                });
            }
        })
            this.renderTopology()
        },
        initX6() {
            var _that = this
            const container = document.getElementById('containerChart');
            const width = container.clientWidth;
            const height = container.clientHeight;

            this.graph = new Graph({
                container: container,
                width: width,
                height: height,
                // 提示

                grid: _that.grid,
                resizing: { //调整节点宽高
                    enabled: true,
                    orthogonal: false,
                },
                // 滚轮缩放
                mousewheel: {
                    enabled: true,
                    modifiers: ['ctrl'],
                },
                panning: true, // 开启平移
                selecting: true, //可选
                snapline: true,
                interacting: {
                    // 边的标签是否可以被移动
                    edgeLabelMovable: false,
                    // 节点是否可以被移动。
                    nodeMovable: false,
                    // 边是否可以被移动。
                    edgeMovable: false
                },
                connecting: { // 节点连接
                    anchor: 'center',
                    connectionPoint: 'anchor',
                    allowBlank: false,
                    snap: true,
                    createEdge() {
                        return new Shape.Edge(_that.edgeObject)
                    },
                },
                highlighting: {
                    magnetAvailable: {
                        name: 'stroke',
                        args: {
                            padding: 4,
                            attrs: {
                                strokeWidth: 4,
                                stroke: '#6a6c8a'
                            }
                        }
                    }
                }
            });

            // 自动缩放以适应容器
            this.graph.centerContent();
            this.graph.zoomToFit({ padding: 20 });
            insertCss(`
              @keyframes ant-line {
                to {
                    stroke-dashoffset: -1000
                }
              }
            `)
        },
        renderTopology() {
            if (!this.graphJson || !this.graphJson.cells) return;

            // 清空画布
            this.graph.clearCells();

            // 渲染所有元素
            const cells = this.graphJson.cells;
            this.graph.fromJSON(cells);

            // 自动缩放以适应容器
            this.graph.centerContent();
            this.graph.zoomToFit({
                padding: 20,
                maxScale: 1.5,
                minScale: 0.1
            });

            // 隐藏连接桩
            this.hidePorts();
        },
        // 显示连接桩
        hidePorts() {
            const container = document.getElementById('containerChart')
            const ports = container.querySelectorAll(
                '.x6-port-body'
            )
            for (let i = 0, len = ports.length; i < len; i = i + 1) {
                ports[i].style.visibility = 'hidden'
            }
        },
        handleClose() {
            this.$emit('update:visible', false);
        }
    }
}
</script>

<style scoped>
.current-floor {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    background: #000;
}

.floor-content {
    width: 100%;
    height: 100%;
    background: url("../../../public/static/background.png");
    background-size: cover;
    position: relative;
    display: flex;
    flex-direction: column;
}

.floor-header {
    width: 100%;
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 60px;
    flex-shrink: 0;
}

.title-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.title {
    font-size: 24px;
    color: #fff;
}

.title-line {
    width: 50px;
    height: 2px;
    background-image: linear-gradient(to right, rgba(15, 61, 104, 1), rgba(41, 155, 255, 1));
    border-radius: 15px;
}

.back {
    width: 36px;
    height: 36px;
    left: 20px;
    cursor: pointer;
    position: absolute;
}

.close-btn {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    line-height: 40px;
    text-align: center;
    font-size: 30px;
    color: #07E6F8;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.3);
}

.floor-body {
    flex: 1;
    width: 100%;
    /* 确保宽度100% */
    padding: 0;
    /* 移除内边距 */
    box-sizing: border-box;
}

.floor-img {
    max-width: 100%;
    height: 100%;
    object-fit: contain;
}

.graph-container {
    width: 100%;
    height: 100%;
    background: transparent;
}

:deep(.x6-graph) {
    background: transparent !important;
    width: 100% !important;
}

:deep(.x6-graph-scroller) {
    width: 100% !important;
    overflow: hidden;
}
</style>